import { render, staticRenderFns } from "./InventoryPlanDetail.vue?vue&type=template&id=a2aff1ca"
import script from "./InventoryPlanDetail.vue?vue&type=script&lang=ts"
export * from "./InventoryPlanDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports